
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"32","height":"32","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M16.8931 22.5C10.0599 22.5 6.1624 17.9955 6 10.5H9.42286C9.53529 16.0015 12.0587 18.3318 14.0574 18.8123V10.5H17.2805V15.2447C19.2543 15.0405 21.3277 12.8784 22.0273 10.5H25.2503C24.7132 13.4309 22.4646 15.5931 20.8656 16.482C22.4646 17.2027 25.0256 19.0886 26 22.5H22.4521C21.6901 20.2177 19.7914 18.452 17.2805 18.2117V22.5H16.8931Z","fill":"currentColor"}})])
          )
        }
      }
    